'use client';

import { useEffect } from 'react';
import { useTheme } from 'next-themes';
import { setCurrentTheme } from '@/src/analytics/hotpads/themeState';

export function useTrackThemeAnalytics(): void {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    if (!resolvedTheme) return;
    setCurrentTheme(resolvedTheme === 'dark' ? 'dark' : 'light');
  }, [resolvedTheme]);
}
